module.exports = __webpack_public_path__ + "static/img/taothuminhnguyet.220b0ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/taothuminhnguyet.png
// module id = 2xcf
// module chunks = 1